module.exports = __webpack_public_path__ + "static/media/liribotTextImage.ed158864.png";